import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import companyService from '@/services/company.service';

interface Props {
  value?: string;
  onChange: (branchId?: string) => void;
  width?: number;
}

/** Optional branch filter for financial reports (empty = all branches). */
const BranchFilterSelect: React.FC<Props> = ({ value, onChange, width = 220 }) => {
  const { t } = useTranslation('finance');
  const { data: branches = [], isLoading } = useQuery({
    queryKey: ['company-branches-selection'],
    queryFn: () => companyService.listBranches({ is_active: true }),
    staleTime: 60000,
  });
  return (
    <Select
      allowClear
      showSearch
      style={{ width }}
      placeholder={t('allBranches')}
      loading={isLoading}
      value={value}
      optionFilterProp="label"
      onChange={(v?: string) => onChange(v)}
      options={branches.map((b) => ({ value: b.id, label: `${b.code} — ${b.name}` }))}
    />
  );
};

export default BranchFilterSelect;
